"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const featureToggles = {
  curatorsComingSoon: () => false,
  schedule: () => true,
  speakersComingSoon: () => false,
  archive: () => true,
  partners: () => true,
  contactFormAuth: () => true,
  liveStream: () => true,
  pressReleases: () => true,
  dragonsComingSoon: () => false
};
var _default = exports.default = featureToggles;